























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { danxuan, jifendanxuan } from "./ziduans";
import Hover from "./hover.vue";
@Component({
  components: {
    Hover
  }
})
export default class ProjectThirdControlDanxuan extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private index: any;
  private defaultValue: any = "";
  private ifShowConfig: boolean = false;
  private temp: any = {
    content: {
      options: []
    }
  };
  /**
   * @description 打开配置弹窗
   */
  private openConfigDialg() {
    this.temp = _.cloneDeep(this.ziduan);
    this.ifShowConfig = true;
  }
  /**
   * @description 切换类型
   */
  private toggleType(type) {
    switch (type) {
      case "单选":
        this.$set(this.temp.content, "id", danxuan.id);
        this.$set(this.temp.content, "type", danxuan.type);
        this.$set(this.temp.content, "options", danxuan.options);
        this.$set(this.temp.content, "value", danxuan.value);
        break;
      case "计分单选":
        this.$set(this.temp.content, "id", jifendanxuan.id);
        this.$set(this.temp.content, "type", jifendanxuan.type);
        this.$set(this.temp.content, "options", jifendanxuan.options);
        this.$set(this.temp.content, "value", jifendanxuan.value);
        break;
    }
  }
  /**
   * @description 新增选项
   */
  private addOption() {
    if (this.temp.content.type === "单选") {
      this.temp.content.options.push("");
    } else if (this.temp.content.type === "计分单选") {
      this.temp.content.options.push({ name: "", score: 1 });
    }
  }
  /**
   * @description 删除这个选项
   */
  private deleteThisOption(option, index) {
    this.temp.content.options.splice(index, 1);
    if (this.temp.content.options.length === 0) {
      if (this.temp.content.type === "单选") {
        this.temp.content.options[0] = "";
      } else if (this.temp.content.type === "计分单选") {
        this.temp.content.options[0] = { name: "", score: 1 };
      }
    }
  }
  /**
   * @description 手动更新选项名
   */
  private nameChange(val, index) {
    // this.temp.content.options[index] = val;
    this.$set(this.temp.content.options, index, val);
  }
  /**
   * @description 保存
   */
  private save() {
    // 检查标题
    if (!this.temp.content.title) {
      this.$message.warning("标题不能为空");
      return;
    }
    // 检查答案
    if (this.temp.content.options.length < 1) {
      this.$message.warning("单选题选项最少需要两项");
      return;
    }
    let valid: boolean = true;
    if (this.temp.content.type === "单选") {
      this.temp.content.options.map((item: any) => {
        if (!item) {
          this.$message.warning("选项不能为空");
          valid = false;
        }
      });
    } else if (this.temp.content.type === "计分单选") {
      this.temp.content.options.map((item: any) => {
        if (!item.name) {
          this.$message.warning("选项不能为空");
          valid = false;
        }
        if (!item.score) {
          this.$message.warning("不能没有分数");
          valid = false;
        }
      });
    }
    if (!valid) {
      return;
    }
    this.$emit("ziduanChange", this.temp);
    this.ifShowConfig = false;
  }
  /**
   * @description 取消/关闭弹窗
   */
  private closeDialog() {
    this.temp = {};
    this.ifShowConfig = false;
  }
  /**
   * @description 删除这个字段
   */
  private deleteThis() {
    this.$emit("del");
  }
}
